import { render } from "./Notes4.vue?vue&type=template&id=687ef3ed&scoped=true"
import script from "./Notes4.vue?vue&type=script&lang=js"
export * from "./Notes4.vue?vue&type=script&lang=js"

import "./Notes4.vue?vue&type=style&index=0&id=687ef3ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687ef3ed"]])

export default __exports__